import { useEffect, useState, useRef } from "react"

const clickOutSideHook = (initialValue) => {
  const [isActive, setIsActive] = useState(initialValue)
  const [resetState, setResetState] = useState(false)
  
  const ref = useRef()

  const handleClickOutSide = (e) => {
    if (ref?.current?.contains(e.target)) {
      return
    }
    else {
      setIsActive(false)
      setResetState(true)
    }
    
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutSide, false)
    document.addEventListener("touchstart", handleClickOutSide);
    setResetState(null)
    return () => {
      document.removeEventListener("mousedown", handleClickOutSide, false)
      document.removeEventListener("touchstart", handleClickOutSide);
      setResetState(true)
    }
  }, [isActive])

  return { isActive, setIsActive, ref, resetState }
}

export default clickOutSideHook